import { useState } from 'react'
import { useQuery } from 'react-query'

import { CircularProgress } from '@mui/material'
import Box from '@mui/material/Box'
import ThemeSite from 'styles/theme-site'
import { semantic } from 'styles/tokens'

import { SITE_DEFAULTS } from 'common/context/agency-theme'
import AgencyService, { Queries } from 'common/services/agency'

import AuthShell, { isPlatformHost } from 'components/ui/auth-shell'

import ForgotPasswordForm from './ForgotPasswordForm'
import { LoginActionEnum, LoginActionType } from './interfaces'
import LoginForm from './LoginForm'

export default function Login({
  initialAction = LoginActionEnum.login
}: {
  initialAction?: LoginActionEnum
}) {
  const queryparams = new URLSearchParams(window.location.search)
  const isAdminModule = Boolean(queryparams.get('admin'))
  const isForgotPasswordAction = queryparams.get('action') === 'forgot'
  const [action, setAction] = useState<LoginActionType>(
    isForgotPasswordAction ? LoginActionEnum.forgotPassword : initialAction
  )

  const ComponentWrapper = () => {
    switch (action) {
      case LoginActionEnum.login:
        return (
          <LoginForm
            isAdminModule={isAdminModule}
            onClickForgotPasswordButton={() =>
              setAction(LoginActionEnum.forgotPassword)
            }
          />
        )

      case LoginActionEnum.forgotPassword:
        return (
          <ForgotPasswordForm
            setAction={() => setAction(LoginActionEnum.login)}
          />
        )

      case LoginActionEnum.loadingPermisions:
        return (
          <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <CircularProgress color='primary' />
          </Box>
        )
    }
  }

  const { data: agency } = useQuery(Queries.detail('default'), () =>
    AgencyService.getDefaultAgency()
  )

  const shell = (
    <AuthShell
      agency={agency}
      bare={action === LoginActionEnum.loadingPermisions}
    >
      <ComponentWrapper />
    </AuthShell>
  )

  // Host da plataforma: tema da Corretto, que ja envolve o app
  if (isPlatformHost()) return shell

  // Host da imobiliaria: as cores dela; sem cor, o painel cai no azul da
  // Corretto e o cliente no padrao do site
  const primaryColor =
    agency?.primaryColor ||
    (isAdminModule ? semantic.primary : SITE_DEFAULTS.primary)
  const secondaryColor =
    agency?.secondaryColor ||
    (isAdminModule ? semantic.secondary : SITE_DEFAULTS.secondary)

  return (
    <ThemeSite primaryColor={primaryColor} secondaryColor={secondaryColor}>
      {shell}
    </ThemeSite>
  )
}
